<template>
    <el-upload
            class="file-upload"
            :action="uploadURL"
            :limit="limit"
            :headers="headerInfo"
            :on-remove="handleRemove"
            :on-success="handleImageUploadSuccess"
            :file-list="getFileList"
            :on-exceed="handleExceed"
            list-type="picture">
        <el-button size="small" type="primary">{{ helpText }}</el-button>
        <div slot="tip" class="el-upload__tip">{{ tip }}</div>
    </el-upload>
</template>

<script>
    export default {
        name: "FileUpload",
        props: {
            // fileList
            fileList: {
                type: Array
            },

            // limit
            limit: {
                type: Number
            },

            // Text
            helpText: {
                type: String
            },

            // Restrictions
            tip: {
                type: String,
                default: ""
            },
        },
        data() {
            return {
                baseURL: this.$http.defaults.baseURL,
                uploadURL: this.$http.defaults.baseURL + 'admin/resources',
                headerInfo: {
                    'Authorization': 'Bearer ' + localStorage.getItem('orca.credentials')
                },
            }
        },
        methods: {
            handleExceed(file, fileList) {
                this.$message({
                    showClose: true,
                    message: 'Maximaal aantal uploads overschreden, gelieve er eerst te verwijderen.',
                    type: 'error'
                });
                return false;
            },
            handleRemove(file, fileList) {
                this.fileList = this.fileList.filter(function( obj ) {
                    return obj.id !== file.id
                });

                // TODO REMOVE FROM SERVER
            },
            handleImageUploadSuccess (response, file, fileList) {
                this.fileList.push(response)
            },
            getAttachmentIds() {
                return this.fileList.map(function(el) {
                    return el.id;
                })
            }
        },
        computed: {
            getFileList() {
                const that = this
                return this.fileList.map(function(el) {
                    return {
                        "id": el.id,
                        "name": el.name,
                        "url": that.baseURL + 'resources/' + el.url
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/dashboard/forms/FileUpload.vue